type SignUpCardProps = {
  img: string;
  header: string;
  description: string;
  onClick: () => void;
};

export const SignUpCard = (props: SignUpCardProps) => {
  const { onClick, img, header, description } = props;
  return (
    <div
      className='flex flex-col gap-4 p-8 w-[311px] h-[284px] items-center justify-center border rounded-xl border-gray-100 cursor-pointer
       hover:shadow-xl transform transition hover:scale-105'
      onClick={onClick}
    >
      <img src={img} width={'100px'} height={'100px'} alt='Volunteer' />
      <div className='font-semibold text-xl text-gray-700'>{header}</div>
      <div className='text-lg text-center'>{description}</div>
    </div>
  );
};
